import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { palette } from '../../../theme';

export interface DescriptionTabProps {
  description: string;
}

const DescriptionTab: FC<DescriptionTabProps> = (props) => {
  return (
    <Box sx={{ padding: '20px', minHeight: 'fit-content' }}>
      <Typography fontSize={14} color={palette.text.primary} sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {props.description || 'No description available.'}
      </Typography>
    </Box>
  );
};

export default DescriptionTab;
